/**
 * ״מסך רחב״ (6ג, D15, RQ-J11): מחשב או טאבלט לרוחב — 1024px ומעלה (A-145).
 *
 * אותו ערך משמש ב־styles.css (`@media (min-width: 1024px)`). הסידור במסך רחב הוא
 * CSS; השאלה הזו נשאלת ב־JS רק כשרכיב צריך להחליט מה להציג — כפתור ״להציג לצד
 * הצ׳קליסט״ (D15: רק במסך רחב), והעברת רשימת הפרקים לעמודה הצדדית.
 *
 * `useSyncExternalStore` מחזיר את הערך הנכון כבר ברינדור הראשון — בלי רינדור
 * ראשון ״צר״ ואחריו קפיצה לסידור הרחב (A-97).
 */

import { useSyncExternalStore } from 'react';

export const WIDE_QUERY = '(min-width: 1024px)';

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(WIDE_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
}

function isWide(): boolean {
  return window.matchMedia(WIDE_QUERY).matches;
}

export function useWideScreen(): boolean {
  return useSyncExternalStore(subscribe, isWide, () => false);
}
